import { buildValidations, validator } from 'ember-cp-validations';
import { or, reads } from '@ember/object/computed';
import Super from './treatable-client';
import classic from 'ember-classic-decorator';
import moment from 'moment-timezone';

const Validations = buildValidations({
  clientRelationships: validator('has-many'),
  firstName: validator('presence', {
    presence: true,
    ignoreBlank: true,
    messageKey: 'errors.firstNameRequired',
    disabled: reads('model.skipContactFormSpecificValidations'),
  }),
  lastName: validator('presence', {
    presence: true,
    ignoreBlank: true,
    messageKey: 'errors.lastNameRequired',
    disabled: reads('model.skipContactFormSpecificValidations'),
  }),
  birthDate: [
    validator('presence', {
      presence: true,
      messageKey: 'errors.blankField',
      disabled: or('model.skipContactFormSpecificValidations', 'model.skipPrescreenerValidation'),
    }),
    validator('inline', {
      validate(value) {
        if (!value || value.isBefore(moment())) return true;

        return 'errors.clientCouple.invalidBirthDate';
      },
    }),
  ],
  state: validator('presence', {
    presence: true,
    descriptionKey: 'errors.clientCouple.state',
    messageKey: 'errors.presence',
    disabled: or('model.skipContactFormSpecificValidations', 'model.skipPrescreenerValidation'),
  }),
});

@classic
export default class ClientCouple extends Super.extend(Validations) {
  isCouple = true;
  skipContactFormSpecificValidations = true;
}
